import { FormattedMessage } from 'react-intl';
import Task from '../../../../../handlers/Event/Task';
import { LPDisplayPart } from './Parts/LPDisplayPart';

type Props = {
    task: Task;
};

export const LPDisplayForceBlack = (props: Props) => {
    return (
        <>
            <FormattedMessage id="tasks.forceLPMatrixDisplaysV2Black" />

            <LPDisplayPart lpDisplay={props.task.getLpMatrixDisplaysV2()} />
        </>
    );
};
